import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const benefits = ['Vas a tener una respuesta clara para la próxima crisis en lugar de improvisar desde el agotamiento', 'Vas a dejar de sentir esa culpa de las 11 PM después de haber gritado más de lo que querías', 'Vas a entender por qué tu hijo explota para dejar de tomártelo como un ataque personal', 'Vas a poder salir a la calle con un plan concreto en lugar de rezar para que no pase nada', 'Vas a recuperar la sensación de ser el adulto que tiene el control de la situación', 'Vas a mejorar el vínculo con tu hijo porque vas a dejar de enfrentarte a él y empezar a acompañarlo', 'Vas a tener frases exactas listas para usar en lugar de quedarte en blanco en el momento más tenso'];
export function Benefits() {
  return <SectionWrapper className="bg-white py-20" data-id="element-39">
      <h2 className="font-sans text-3xl md:text-4xl font-bold text-ink mb-12 text-center" data-id="element-40">
        Lo que esto significa en tu vida real:
      </h2>

      <div className="space-y-4 max-w-3xl mx-auto" data-id="element-41">
        {benefits.map((benefit, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.4
      }} className="flex items-start gap-4 bg-cream p-5 rounded-xl border border-hairline" data-id="element-42">
            <div className="bg-sage-light p-1 rounded-full shrink-0 mt-0.5" data-id="element-43">
              <CheckIcon className="w-5 h-5 text-sage" data-id="element-44" />
            </div>
            <p className="font-sans text-lg text-ink-mid leading-relaxed font-medium" data-id="element-45">
              {benefit}
            </p>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}